import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';
// import { Link } from 'react-router-dom';

export default function Code({ brokerServiceUrl }) {
  const content1 = `
  如果使用maven构建项目，将下述配置添加到 pom.xml 文件中：

  ~~~xml~DEV_JAVA_MAVEN_GRADLE_1_COPY
  <pulsar.version>2.10.6.10</pulsar.version>
  <dependency>
    <groupId>com.ascentstream.pulsar</groupId>
    <artifactId>pulsar-client</artifactId>
    <version>$\{pulsar.version}</version>
  </dependency>
  ~~~
  如果使用gradle构建项目，将下述配置添加到 build.gradle文件中：

  ~~~groovy~DEV_JAVA_MAVEN_GRADLE_2_COPY
  def pulsarVersion = '2.10.6.10'
  dependencies {
    compile group: 'com.ascentstream.pulsar', name: 'pulsar-client', version: pulsarVersion
  }
  ~~~
  `;
  const content2 = `
  ~~~java~DEV_JAVA_PRODUCER_COPY
  import org.apache.pulsar.client.api.*;
  
  public class ProducerExample {
  
      private static final String serviceUrl = "${brokerServiceUrl}";
      private static final String topic = "persistent://public/default/test" ;
  
      public static void main(String[] args) throws PulsarClientException {
          PulsarClient client = PulsarClient.builder()
              .serviceUrl(serviceUrl)
              .authentication(
                  // YOUR_PULSAR_TOKEN需要在角色菜单中自行配置
                  AuthenticationFactory.token(YOUR_PULSAR_TOKEN)
              )
              .build();
          Producer<byte[]> producer = client.newProducer()
              .topic(topic)
              .create();
  
          MessageId msgId = producer.send("Hello World!".getBytes());
          System.out.println("msgId " + msgId);
          producer.close();
          client.close();
      }
  }
  ~~~
  `;
  const content3 = `
  ~~~java~DEV_JAVA_CONSUMER_COPY
  import org.apache.pulsar.client.api.*;
  
  public class ConsumerExample {
  
      private static final String serviceUrl = "${brokerServiceUrl}";
      private static final String topic = "persistent://public/default/test";
      private static final String sub = "test_sub";
  
      public static void main(String[] args) throws PulsarClientException {
          
          PulsarClient client = PulsarClient.builder()
              .serviceUrl(serviceUrl)
              .authentication(
                // YOUR_PULSAR_TOKEN需要在角色菜单中自行配置
                  AuthenticationFactory.token(YOUR_PULSAR_TOKEN)
              )
              .build();
  
          Consumer consumer = client.newConsumer()
              .topic(topic)
              .subscriptionName(sub)
              .subscriptionType(SubscriptionType.Shared)
              .subscribe();
  
          while (true) {
              Message<byte[]> message = consumer.receive();
              try {
                  // 业务逻辑处理
                  System.out.println("Message Id : " + message.getMessageId() + ", Message Data : " + new String(message.getData()));
                  // 消息确认
                  consumer.acknowledge(message);
              } catch (PulsarClientException e) {
                  //消息处理失败，稍后重新发送
                  consumer.negativeAcknowledge(message);
              }
          }
      }
  }
  ~~~
  `;

  const onChange = (val) => doBuried({ eventId: val });

  return (
    <Tabs defaultValue='DEV_JAVA_MAVEN_GRADLE' onChange={onChange}>
      <TabPanel value='DEV_JAVA_MAVEN_GRADLE' label='Maven/Gradle'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_JAVA_PRODUCER' label='Producer'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_JAVA_CONSUMER' label='Consumer'>
        <Markdown content={content3} />
      </TabPanel>
    </Tabs>
  );
}
